/**
 * Seiten-Model (Info oder Aufgabe)
 * @class service_v3sItem
 * @memberOf v3sWbtPlayerApp:model
 */
angular.module('v3sWbtPlayerApp').factory('v3sItem', ["$rootScope", "v3sExercise", "v3sLog", "v3sBrowserInfoService", function ($rootScope, v3sExercise, v3sLog, v3sBrowserInfoService) {


    // instantiate the item object
    var v3sItem = function (data) {
        this.id = "";
        this.path = "";
        this.pathMobile = "";
        this.title = "";
        this.type = "";
        this.lastAccess = 0;

        this.next = null;
        this.previous = null;
        this.first = null;
        this.last = null;

        this.parent = null;
        this.exercise = null;
        this.status = "not attempted";
        this.lastStatus = "not attempted";
        this.score = undefined;

        this.trackable = true;
        this.locked = false;
        this.visible = true;

        this.parameters = {};

        this.keywords = "";

        this.tags = [];

        this.ScormDataEnum = {
            STATUS: 0,
            SCORE: 1,
            CHILDREN: 2,
            TEST_DATA: 3,
            LOCK: 4,
            TRACKABLE: 5,
            VISIBLE: 6
        };

        this.changed = false;

        if (!!data) {
            angular.extend(this, data);
            this.loadParameters(data.parameters);
        }

        if (!!this.children) {
            this.children = [];
        }

        this.applyParameters();
        this.statusExcludeFilter = ["not attempted", "incomplete"];
        this.trackableExcludeFilter = [this.trackable];
        this.lockExcludeFilter = [this.locked];
        this.visibleExcludeFilter = [this.visible];
    };

    v3sItem.prototype.loadParameters = function (parameters) {
        var newParameters = {};

        if (!!parameters) {
            var splitParams = parameters.split(';');
            angular.forEach(splitParams, function (param) {
                var splitParam = param.split("=");
                if (splitParam.length > 1) {
                    newParameters[splitParam[0]] = splitParam[1];

                } else {
                    newParameters[splitParam[0]] = true;
                }
            });
        }
        this.parameters = newParameters;
    }

    v3sItem.prototype.applyParameters = function (parameters) {
        if (!parameters) {
            parameters = this.parameters;
        }

        if (!!parameters.next) {
            this.next = parameters.next;
        }

        if (!!parameters.previous) {
            this.previous = parameters.previous;
        }

        if (!!parameters.first) {
            this.first = parameters.first;
        }

        if (!!parameters.last) {
            this.last = parameters.last;
        }

        if (parameters.trackable === false) {
            this.trackable = false;
        }

        if (parameters.lock === true) {
            this.locked = true;
        }

        if (parameters.visible === false) {
            this.visible = false;
        }

        if (!!parameters.tags) {
            this.tags = parameters.tags.split(",");;
        }
    }

    v3sItem.prototype.getId = function () {
        return this.id;
    };

    v3sItem.prototype.getTitle = function () {
        return this.title;
    };

    v3sItem.prototype.hasTag = function (tag) {
        return this.tags.indexOf(tag) >= 0;
    };

    v3sItem.prototype.getPath = function () {
        return v3sBrowserInfoService.isResponsiveView() ? this.pathMobile : this.path;
    };

    v3sItem.prototype.getPrevious = function () {
        var previous = null;
        var parent = this.getParent();
        if (!!parent) {
            previous = parent.getPreviousChild(this);
        }
        return previous;
    };

    v3sItem.prototype.getNext = function () {
        var next = null;
        var parent = this.getParent();
        if (!!parent) {
            next = parent.getNextChild(this);
        }
        return next;
    };

    v3sItem.prototype.isLocked = function () {
        var locked = this.locked;

        if (!locked && this.parent) {
            locked = this.parent.isLocked();
        }

        return locked;
    };

    v3sItem.prototype.setLocked = function (locked) {
        if (locked !== undefined && locked !== null) {
            locked = !!locked; //1/0 -> true/false

            if (this.locked != locked) {
                this.locked = locked;

                if (!!this.parent && typeof (this.parent.update) === "function") {
                    this.parent.update();
                }

                this.notifyPageChanged();  
            }

            this.updateLastAccess();
        }
    };

    v3sItem.prototype.isVisible = function () {
        var visible = this.visible;

        if (visible && this.parent !== null) {
            visible = this.parent.isVisible();
        }

        if (visible) {
            if (v3sBrowserInfoService.isResponsiveView()) {
                visible = !!this.pathMobile;
            } else {
                visible = !!this.path;
            }
        }

        return visible;
    };

    v3sItem.prototype.setVisible = function (visible) {
        if (visible !== undefined && visible !== null) {
            visible = !!visible; //1/0 -> true/false

            if (this.visible != visible) {
                this.visible = visible;

                if (!!this.parent && typeof (this.parent.update) === "function") {
                    this.parent.update();
                }

                this.notifyPageChanged();
                
            }

            this.updateLastAccess();
        }
    };

    v3sItem.prototype.isScorable = function () {
        return this.isExercise() && this.isTrackable();
    };

    v3sItem.prototype.getScoredItemsCount = function () {
        return this.isExercise() ? 1 : 0;
    };

    v3sItem.prototype.getExercisesCount = function () {
        return this.isExercise() ? 1 : 0;
    };

    v3sItem.prototype.getExerciseStatistic = function () {
        var statisticData = { count: 0, correct: 0, wrong: 0, score: 0 };

        if (this.isScorable()) {
            statisticData.count = this.getExercisesCount();
            statisticData.score = this.getScore();
            statisticData.correct = Math.round(statisticData.count * statisticData.score / 100); //damit auch in Section und SCO gültig
            statisticData.wrong = statisticData.count - statisticData.correct;
        }

        return statisticData;
    };

    v3sItem.prototype.getScoredData = function () {
        var scoredData = { score: 0, count: 0, evaluated: 0 };

        if (this.isTrackable()) {
            scoredData.score = this.getScore();
            scoredData.count = this.getScoredItemsCount();
            scoredData.evaluated = this.isEvaluated() ? 1 : 0;
        }

        return scoredData;
    };

    v3sItem.prototype.updateTreeDepth = function () {
        var tmpParent = this;
        this.treeDepth = -1;

        while (!!tmpParent) {
            tmpParent = tmpParent.getTreeParent();
            this.treeDepth++;
        }
    };

    v3sItem.prototype.isTreeParent = function (parent) {
        var tmpParent = this;

        while (!!tmpParent) {
            if (parent === tmpParent) {
                return true;
            }
            tmpParent = tmpParent.getTreeParent();
        }

        return false;
    };

    v3sItem.prototype.isParent = function (parent) {
        var tmpParent = this;

        while (!!tmpParent) {
            if (parent === tmpParent) {
                return true;
            }
            tmpParent = tmpParent.getParent();
        }

        return false;
    };

    v3sItem.prototype.getParent = function () {
        return this.parent;
    };

    v3sItem.prototype.getTreeParent = function () {
        return this.getParent();
    };

    v3sItem.prototype.getSco = function () {
        var tItem = this;
        while (!!tItem) {
            if (tItem.sco === true) {
                return tItem;
            } else {
                tItem = tItem.getParent();
            }
        }
        return null;
    };

    v3sItem.prototype.getWbt = function () {
        var tItem = this;
        while (!!tItem.parent) {
            tItem = tItem.getParent();
        }
        return tItem;
    };

    v3sItem.prototype.getPageBackground = function () {
        var background = { 'color': '', 'image': '', 'responsiveColor': '', 'responsiveImage': '' };

        var item = this;

        while (!!item && (!background.color || !background.image || !background.ResponsiveColor || !background.imageResponsive)) {
            if (!background.color && !!item.pageBackgroundColor) {
                background.color = item.pageBackgroundColor;
            }
            if (!background.responsiveColor && !!item.pageResponsiveBackgroundColor) {
                background.responsiveColor = item.pageResponsiveBackgroundColor;
            }

            if (!background.image && !!item.pageBackgroundImage) {
                background.image = item.pageBackgroundImage;
            }

            if (!background.responsiveImage && !!item.pageResponsiveBackgroundImage) {
                background.responsiveImage = item.pageResponsiveBackgroundImage;
            }

            item = item.getTreeParent();
        }

        return background;
    };

    v3sItem.prototype.getPlayerBackground = function () {
        var background = { 'color': '', 'image': '' };

        var item = this;

        while (!!item && (!background.color || !background.image)) {
            if (!background.color && !!item.playerBackgroundColor) {
                background.color = item.playerBackgroundColor;
            }

            if (!background.image && !!item.playerBackgroundImage) {
                background.image = item.playerBackgroundImage;
            }

            item = item.getTreeParent();
        }

        return background;
    };

    v3sItem.prototype.getHideState = function (prop) {
        var hide = false;

        var item = this;

        while (!!item && (!hide)) {
            if (!!item[prop]) {
                hide = item[prop];
            }

            item = item.getTreeParent();
        }

        return hide;
    };

    v3sItem.prototype.setStatus = function (status, options) {
        options = options || {};
        var result = false;

        if (status === "incomplete" || status === "completed") {
            if (this.status != status && (options.overwrite || this.status !== "completed") &&
                !(options.resetOnlyAttempted && status === "incomplete" && this.status === "not attempted")) {
                this.status = status;

                if (this.isExercise()) {
                    if ((this.status === "completed" && this.score === undefined) //nach der Aktion Completed, sonst werden die Aufgaben/Sektionen/SCOs nicht als failed erkannt
                        || (this.status === "incomplete" && this.score === 100)) { //nach der Aktion Incomplete, sonst werden die Aufgaben/Sektionen/SCOs als passed erkannt
                        this.score = 0;
                    }
                }

                result = true;
                this.notifyPageChanged(true);  
            }

            this.updateLastAccess();
        }

        return result;
    };

    v3sItem.prototype.getStatus = function () {
        var status = "";

        if (this.isTrackable()) {
            status = this.status;
            if (status == "not attempted") {
                var sco = this.getSco();
                if (this != sco && sco.getStatus() != "not attempted") {
                    status = "incomplete";
                }
            }
        }

        return status;
    };

    v3sItem.prototype.complete = function () {
        if (this.isTrackable()) {
            this.lastStatus = "completed";
            this.setStatus("completed");
        }
    };

    v3sItem.prototype.incomplete = function () {
        if (this.isTrackable()) {
            this.lastStatus = "incomplete";
            this.setStatus("incomplete");
        }
    };

    v3sItem.prototype.isCompleted = function () {
        return this.status === "completed";
    };

    v3sItem.prototype.isLastCompleted = function () {
        return this.lastStatus === "completed";
    };

    v3sItem.prototype.isTrackable = function () {
        var trackable = this.trackable;

        if (trackable && this.parent !== null) {
            trackable = this.parent.isTrackable();
        }

        return trackable;
    };

    v3sItem.prototype.setTrackable = function (trackable) {
        if (trackable !== undefined && trackable !== null) {
            trackable = !!trackable; //1/0 -> true/false

            if (this.trackable != trackable) {
                this.trackable = trackable;

                this.notifyPageChanged();
                
            }

            this.updateLastAccess();            
        }
    };

    v3sItem.prototype.formatStatusToString = function (status) {
        var nStatus = parseInt(status, 10);

        if (nStatus === 2) {
            status = "completed";
        } else if (nStatus === 1) {
            status = "incomplete";
        } else if (nStatus === 0) {
            status = "not attempted";
        }

        return status;
    };

    v3sItem.prototype.formatStatusToNumber = function (status) {
        if (status === "completed") {
            status = 2;
        } else if (status === "incomplete") {
            status = 1;
        } else {
            status = 0;
        }

        return status;
    };

    v3sItem.prototype.isPassed = function () {
        return this.getExerciseStatus() == "passed";
    };

    v3sItem.prototype.isLastPassed = function () {
        return this.exercise && this.exercise.isPassed();
    };

    v3sItem.prototype.isEvaluated = function () {
        return this.score >= 0; // soll definiert sein!
    };

    v3sItem.prototype.isLastEvaluated = function () {
        return this.exercise && this.exercise.isCompleted();
    };

    v3sItem.prototype.evaluate = function (score) {
        if (this.isTrackable() && !!this.exercise) {
            var scoreChanged = this.setScore(score);
            if (!scoreChanged) {
                this.notifyPageChanged(false);
            }
        }
    };

    v3sItem.prototype.parseScore = function (score) {
        if (score !== undefined) {
            score = Math.round((parseFloat(score)) * 100) / 100;
            if (score < 0) score = 0;
            else if (score > 100) score = 100;
        }
        
        return score;
    };

    v3sItem.prototype.setScore = function (score, options) {
        var result = false;
        options = options || {};
        score = this.parseScore(score);

        if (this.isScorable() && !isNaN(score)) {
            if (this.score != score && (!!options.overwrite || !this.score || this.score < score) &&
                !(options.resetOnlyAttempted && score === 0 && this.score === undefined)) {
                this.score = score;

                if (this.status != "completed" && this.isExercise()) {
                    this.status = "completed"; //nach der Aktion Failed/Passed werden sonst die Aufgaben nicht als failed/passed markiert
                }

                result = true;

                this.notifyPageChanged();               
            }

            this.updateLastAccess();
        }
        return result;
    };

    v3sItem.prototype.getScore = function () {
        return this.score >= 0 ? this.parseScore(this.score) : 0;
    };

    v3sItem.prototype.getProgress = function () {
        var progress = { completed: 0, count: 0 };

        if (this.isTrackable()) {
            progress.count++;

            if (this.isCompleted()) {
                progress.completed++;
            }
        }

        return progress;
    };

    v3sItem.prototype.isInfo = function () {
        return this.type === "info";
    };

    v3sItem.prototype.isExercise = function () {
        return this.type === "exercise";
    };

    v3sItem.prototype.getType = function () {
        return this.type;
    };

    v3sItem.prototype.getExerciseStatus = function () {
        var status = "";

        if (this.isScorable()) {
            if (this.isCompleted() && this.isEvaluated() && this.score == 100) {
                status = "passed";
            } else {
                status = "failed";
            }
        }

        return status;
    };

    v3sItem.prototype.updateLastAccess = function () {
        this.lastAccess = new Date().getTime();

        if (!!this.parent && typeof (this.parent.update) === "function") {
            this.parent.update();
        }

        var treeParent = this.getTreeParent();
        if (!!treeParent && treeParent != this.parent && typeof (treeParent.update) === "function") {
            treeParent.update();
        }
    };

    v3sItem.prototype.getLastAccess = function () {
        return this.lastAccess;
    };

    v3sItem.prototype.getExercise = function () {
        return this.exercise;
    };

    v3sItem.prototype.initExercise = function (data) {
        this.exercise = new v3sExercise(this, data);
        return this.exercise;
    };

    v3sItem.prototype.clean = function () {
        if (!!this.exercise) {
            this.exercise.clean();
            this.exercise = null;
        }
    };

    v3sItem.prototype.resetData = function () {
        this.applyParameters();

        this.lastAccess = 0;

        if (this.status == "completed") {
            this.status = "incomplete";
        }

        if (this.score > 0) {
            this.score = 0;
        }

        this.notifyPageChanged();
        this.updateLastAccess();
        
    };

    v3sItem.prototype.changeProperties = function (properties) {
        if (properties.indexOf("trackable") >= 0) {
            this.setTrackable(true);
        } else if (properties.indexOf("not trackable") >= 0) {
            this.setTrackable(false);
        }

        if (properties.indexOf("completed") >= 0) {
            this.setStatus("completed", { overwrite: true });
        } else if (properties.indexOf("incomplete") >= 0) {
            this.setStatus("incomplete", { overwrite: true, resetOnlyAttempted: true });
        }

        if (properties.indexOf("passed") >= 0) {
            this.setScore(100, { overwrite: true });
        } else if (properties.indexOf("failed") >= 0) {
            this.setScore(0, { overwrite: true, resetOnlyAttempted: true });
        }

        if (properties.indexOf("locked") >= 0) {
            this.setLocked(true);
        } else if (properties.indexOf("unlocked") >= 0) {
            this.setLocked(false);
        }

        if (properties.indexOf("visible") >= 0) {
            this.setVisible(true);
        } else if (properties.indexOf("invisible") >= 0) {
            this.setVisible(false);
        }
    };

    v3sItem.prototype.getScormData = function (excludeFilter) {
        //obsolete
    };

    v3sItem.prototype.setScormData = function (data) {
        //obsolete
        if (!!data && data.length > 0) {
            this.setStatus(this.formatStatusToString(data[this.ScormDataEnum.STATUS]), { overwrite: true });
            this.setScore(data[this.ScormDataEnum.SCORE], { overwrite: true });
            this.setLocked(data[this.ScormDataEnum.LOCK]);
            this.setTrackable(data[this.ScormDataEnum.TRACKABLE]);
            this.setVisible(data[this.ScormDataEnum.VISIBLE]);
        }
    };

    v3sItem.prototype.getGlobalScormData = function (data, excludeFilter) {
        if (!!data) {
            var scormData = [];
            excludeFilter = excludeFilter || [];

            if (this.statusExcludeFilter.indexOf(this.status) == -1 && excludeFilter.indexOf(this.ScormDataEnum.STATUS) == -1) {
                scormData[this.ScormDataEnum.STATUS] = this.formatStatusToNumber(this.status);
            }

            if (this.score >= 0 && excludeFilter.indexOf(this.ScormDataEnum.SCORE) == -1) {
                scormData[this.ScormDataEnum.SCORE] = this.parseScore(this.score);
            }

            if (this.trackableExcludeFilter.indexOf(this.trackable) == -1  && excludeFilter.indexOf(this.ScormDataEnum.TRACKABLE) == -1) {
                scormData[this.ScormDataEnum.TRACKABLE] = this.trackable;
            }

            if (this.lockExcludeFilter.indexOf(this.locked) == -1 && excludeFilter.indexOf(this.ScormDataEnum.LOCK) == -1) {
                scormData[this.ScormDataEnum.LOCK] = this.locked;
            }

            if (this.visibleExcludeFilter.indexOf(this.visible) == -1 && excludeFilter.indexOf(this.ScormDataEnum.VISIBLE) == -1) {
                scormData[this.ScormDataEnum.VISIBLE] = this.visible;
            }

            if (scormData.length > 0) {
                data[this.id] = scormData;
            }
        }
    };

    v3sItem.prototype.setGlobalScormData = function (data) {
        if (!!data && !!data[this.id] && data[this.id].length > 0) {
            this.setStatus(this.formatStatusToString(data[this.id][this.ScormDataEnum.STATUS]), { overwrite: true });
            this.setScore(data[this.id][this.ScormDataEnum.SCORE], { overwrite: true });
            this.setLocked(data[this.id][this.ScormDataEnum.LOCK]);
            this.setTrackable(data[this.id][this.ScormDataEnum.TRACKABLE]);
            this.setVisible(data[this.id][this.ScormDataEnum.VISIBLE]);          
        }
    };

    v3sItem.prototype.subscribePageChanged = function (scope, callback) {
        var handler = $rootScope.$on('v3sItemChanged', callback);
        scope.$on('$destroy', handler);
    }

    v3sItem.prototype.notifyPageChanged = function (scormDataChanged) {
        $rootScope.$emit('v3sItemChanged', this);
        if (scormDataChanged !== false) {
            this.changed = true;
        }
    }

    v3sItem.prototype.getChangeCount = function () {
        return this.changed ? 1 : 0;
    };

    v3sItem.prototype.resetChangeCount = function () {
        this.changed = false;
    }

    return v3sItem;
}]);